import { SagaIterator } from 'redux-saga';
import { CARBON_INTENSITY_FETCH } from 'src/modules/carbon-intensity/actions/CarbonIntensityActions';
import { loadCarbonIntensity } from 'src/modules/carbon-intensity/sagas/utils/loadCarbonIntensity';
import { logDebug, logError } from 'src/sagas/utils/logging';
import { call, put } from 'typed-redux-saga';

export function* fetchCarbonIntensity(): SagaIterator<void> {
  try {
    yield* call(logDebug, 'Fetching carbon intensity...');

    const data = yield* call(loadCarbonIntensity);
    yield* put(CARBON_INTENSITY_FETCH.trigger(data));

    yield* call(logDebug, 'Fetching carbon intensity... done');
  } catch (error) {
    yield* call(logError, 'Fetching carbon intensity... error', error);
    throw error;
  }
}
